export default "__VITE_ASSET__CnMw5iyf__"